// extracted by mini-css-extract-plugin
export default {"badgesContainer":"WorkflowBadges_badgesContainer__LGgtD"};